import { Component, effect, inject, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { BaseConfigurableComponent } from '@app/base-config.component';
import { LoadingComponent } from '@app/components/global/loading/loading.component';
import { BranchService } from '@app/services/branch/branch.service';
import { CalendarAvailabilityService } from '@app/services/calendarAvailability/calendarAvailability.service';
import { CategoriesService } from '@app/services/categories/categories.service';
import { Availabilities } from '@app/services/fetch/availability';
import { Services } from '@app/services/fetch/service';
import { SchedulerStepService } from '@app/services/step/scheduler-step.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'afcu-deep-link',
  standalone: true,
  imports: [LoadingComponent],
  templateUrl: './deep-link.component.html',
  styleUrl: './deep-link.component.css'
})
export class DeepLinkComponent extends BaseConfigurableComponent implements OnDestroy{

  private router = inject(Router)

  protected schedulerService = inject( SchedulerStepService )
  protected serviceService = inject( Services )
  protected branchService = inject( BranchService )
  protected categoriesService = inject( CategoriesService );
  protected availabilityService = inject( Availabilities );
  protected calendarAvailabilityService = inject( CalendarAvailabilityService );
  
  private destroy$ = new Subject<void>();

  private continue = true

  constructor() {
    super('')

    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {

      if(params['staff']){
        this.calendarAvailabilityService.staffSelected.set(params['staff'].toString())
      }
      
      if(params['loc'] !== undefined){
        this.schedulerService.branchSelected.set(params['loc'])
        this.serviceService.branchID.set(params['loc'])
        
        if (this.deepLink.serv === -1)
          this.router.navigate(['services', params['loc'] ], { replaceUrl: true })

      } else {
        this.router.navigate(['branches-location'], { replaceUrl: true, queryParamsHandling: 'preserve' })
      }
      
      if(this.deepLink.serv === -1 && params['loc'] === undefined){
        this.router.navigate(['branches-location'], { replaceUrl: true, queryParamsHandling: 'preserve' })
      }

      if(params['lang']){
        this.textService.setLanguage(params['lang'])
      }

    })

    effect(() => {
      if(this.continue)
        if(this.serviceService.servicesRessource.value() !== undefined && this.schedulerService.payload()['services'] === undefined && this.serviceService.servicesRessource.value() !== null ) {
          const deepLinkService = this.serviceService.servicesRessource.value()?.serviceList.filter(serv => serv.service.serviceID === Number(this.deepLink.serv) )[0]
          if (deepLinkService !== undefined){
            this.schedulerService.setPayload('services', {description: deepLinkService.service.name} as CategorySelected)
            this.router.navigate(['calendar'])
          } else {
            if(this.serviceService.branchID() !== '' && this.serviceService.servicesRessource.value() !== null){
              if( deepLinkService === undefined && this.deepLink.serv === -1){}else{
                this.router.navigate(['information', 'wrongService'], { replaceUrl: true, queryParams: { branch: this.serviceService.branchID()} })
              }
            }
          }
        }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
